import { ContentPictureSource } from '../interfaces'

export const appendLocationSingle = (
    folder: string,
    asset: string | undefined
): string => {
    const { REACT_APP_ASSET_PATH } = process.env
    const REACT_APP_BASE_URL = window.location.origin+'/'
    const singleLocationString =
        asset === undefined
            ? ''
            : `${REACT_APP_BASE_URL}${REACT_APP_ASSET_PATH}${folder}/${asset}`
    return singleLocationString
}

export const appendLocationMultiple = (
    folder: string,
    assets: ContentPictureSource[] | undefined
): string => {
    let multipleLocationsArray: string[] = []
    const { REACT_APP_ASSET_PATH } = process.env
    const REACT_APP_BASE_URL = window.location.origin+'/'
    if (assets !== undefined) {
        assets.forEach((picture) => {
            multipleLocationsArray.push(
                `${REACT_APP_BASE_URL}${REACT_APP_ASSET_PATH}${folder}/${picture.sourceSet} ${picture.wDescriptors}`
            )
        })
    }

    const multipleLocationsString = multipleLocationsArray.toString()
    return multipleLocationsString
}

export const appendSizes = (
    assets: ContentPictureSource[] | undefined
): string => {
    let sizesArray: string[] = []
    if (assets !== undefined) {
        assets.forEach((picture) => {
            sizesArray.push(`${picture.mediaCondition}`)
        })
    }

    const sizesString = sizesArray.toString()
    return sizesString
}
